import { InstrumentStatus } from '@foundation/apis/payments';
import { useTranslation } from '@shared/localization';
import cn from 'clsx';
import { JSX } from 'react';

import { PillType } from '@/components/common/pills/enums';
import { FilledPill } from '@/components/common/pills/FilledPill';
import { type IManagePaymentInstrument } from '@/services/payments/instruments/MandateReference';

interface IInstrumentStatusBadgeProps {
  readonly instrument: IManagePaymentInstrument;
  readonly extraClassName: string;
}

const styles = {
  indicator: 'mr-1 h-2 w-2 rounded-full',
};

const InstrumentStatusBadgeIndicator = ({
  extraClassName,
}: {
  extraClassName?: string;
}) => <span className={cn(styles.indicator, extraClassName)} />;

export function InstrumentStatusBadge({
  instrument,
  extraClassName,
}: IInstrumentStatusBadgeProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <>
      {instrument.status === InstrumentStatus.Expired && (
        <FilledPill
          type={PillType.Error}
          text={t('Expired')}
          icon={<InstrumentStatusBadgeIndicator extraClassName="bg-red-700" />}
          extraClassName={extraClassName}
        />
      )}
      {instrument.status === InstrumentStatus.TemporarilyUnavailable && (
        <FilledPill
          type={PillType.Info}
          text={t('Unavailable')}
          extraClassName={extraClassName}
        />
      )}
      {instrument.isDefault && (
        <FilledPill
          type={PillType.Primary}
          text={t('Default')}
          icon={<InstrumentStatusBadgeIndicator extraClassName="bg-white" />}
          extraClassName={extraClassName}
        />
      )}
    </>
  );
}
